<header layout="row">

	<div class="margin-right-10" *ngIf="!comment.isRemoved">
		<vb-profile-picture [profileUrl]="comment.userProfileImageUri"></vb-profile-picture>
	</div>

	<div flex="fill">
		<div [ngClass]="styles.author">{{comment.firstName}} {{comment.lastName}}</div>
		<div layout="row" class="padding-top-5">
			<div [ngClass]="styles.date">{{comment.date | vbDateTimeMedium}}</div>
			<vb-loading-spinner [hidden]="!isProcessing" [size]="'small'"></vb-loading-spinner>
			<video-comment-menu [hidden]="isProcessing" [ngClass]="styles.menu" [menuConfig]="commentMenuConfig" (onMenuItemClick)="onMenuItemClick($event)">
			</video-comment-menu>
		</div>
	</div>

</header>

<vb-ui-toggle-content-display *ngIf="!comment.isRemoved" [minHeight]="100">
	<div [ngClass]="styles.comment" #vbUiToggleItem>
		<span [innerHTML]="comment.text | safeHtml"></span>
	</div>
</vb-ui-toggle-content-display>

<div *ngIf="comment.isRemoved" [ngClass]="styles.comment">{{ 'Media_Videos_Comments_CommentRemoved' | translate }}</div>

<add-video-comment *ngIf="isAddReply" [ngClass]="styles.addComment" [parentCommentId]="comment.parentCommentId || comment.id" [videoId]="comment.videoId" [showCommentForm]="'true'" (onCancelComment)="isAddReply = false">
</add-video-comment>

<vb-confirmation-dialog #deleteConfirmationDialog [title]="'Media_Videos_Comments_DeleteComment' | translate" [message]="'Media_Videos_Comments_DeleteCommentMsg' | translate" [cancelText]="'Cancel' | translate" [actionText]="'Ok' | translate">
</vb-confirmation-dialog>
